import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetItemLocationTypesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetItemLocationTypesQuery = { __typename?: 'Query', getItemLocationTypes: Array<{ __typename?: 'ItemLocationType', id: number, type: string }> };


export const GetItemLocationTypesDocument = gql`
    query GetItemLocationTypes {
  getItemLocationTypes {
    id
    type
  }
}
    `;

/**
 * __useGetItemLocationTypesQuery__
 *
 * To run a query within a React component, call `useGetItemLocationTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetItemLocationTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetItemLocationTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetItemLocationTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetItemLocationTypesQuery, GetItemLocationTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetItemLocationTypesQuery, GetItemLocationTypesQueryVariables>(GetItemLocationTypesDocument, options);
      }
export function useGetItemLocationTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetItemLocationTypesQuery, GetItemLocationTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetItemLocationTypesQuery, GetItemLocationTypesQueryVariables>(GetItemLocationTypesDocument, options);
        }
export type GetItemLocationTypesQueryHookResult = ReturnType<typeof useGetItemLocationTypesQuery>;
export type GetItemLocationTypesLazyQueryHookResult = ReturnType<typeof useGetItemLocationTypesLazyQuery>;
export type GetItemLocationTypesQueryResult = Apollo.QueryResult<GetItemLocationTypesQuery, GetItemLocationTypesQueryVariables>;